import React from 'react';
import { CacheProvider } from '@emotion/react';
import { emotionCache } from './emotion-cache';
import SiteCore from './src/templates/SiteCore';
import MaintenanceScreen from './src/components/MaintenanceScreen';
import isMaintenanceMode from './src/utils/maintenanceMode';

export const wrapPageElement = ({ element, props }) => {
    // Maintenance mode is a full takeover: every route — static pages and
    // /secure/ alike — renders the maintenance screen and nothing else, so no
    // app chrome is mounted behind it. Off unless GATSBY_MAINTENANCE_MODE says
    // otherwise.
    if (isMaintenanceMode()) {
        return (
            <CacheProvider value={emotionCache}>
                <MaintenanceScreen />
            </CacheProvider>
        );
    }

    if (props.location.pathname.startsWith('/secure/')) {
        return element;
    }
    return (
        <CacheProvider value={emotionCache}>
            <SiteCore {...props}>{element}</SiteCore>
        </CacheProvider>
    );
};
